import { CircularLoading, Form, useToast } from '@foxtaibox/foxtailbox-frontend-core';
import { useSetCandidateAgreementTrueMutation } from '@generated/graphql';
import { Box, Button, Stack, Typography } from '@mui/material';
import Card from 'components/Card';
import ROUTES from 'constants/routes';
import useAppNavigate from 'hooks/useAppNavigate';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import useMe from 'store/user/useMe';
import AgreementCheckbox from './components/AgreementCheckbox';
import { ConfirmDataForm } from './types';

const ConfirmData = () => {
  const { me, loading: meLoading } = useMe();
  const { showErrorToast, showSuccessToast } = useToast();
  const navigate = useAppNavigate();
  const { t } = useTranslation();

  const form = useForm<ConfirmDataForm>({
    values: {
      confirmAgreement: me?.agreement || false,
    },
  });
  const { handleSubmit } = form;

  const [saveAgreement, { loading: saveAgreementLoading }] = useSetCandidateAgreementTrueMutation();

  const onSaveCandidateData = async () => {
    try {
      const resAgreement = await saveAgreement();
      const isAgreementSaved = !!resAgreement.data?.setCandidateAgreementTrue.agreement;
      if (!isAgreementSaved) throw new Error(t('languageSelect.errorSavingAgreement'));

      showSuccessToast(t('successMessage'));
      navigate(ROUTES.ASSESSMENT, { goToRedirectUrlIfExists: true });
    } catch (error: Error | unknown) {
      const errorMessage = error instanceof Error ? error.message : t('errors.common');
      // eslint-disable-next-line no-console
      console.error(errorMessage);
      showErrorToast(errorMessage);
    }
  };

  useEffect(() => {
    if (!meLoading && me?.agreement) {
      navigate(ROUTES.ASSESSMENT, { goToRedirectUrlIfExists: true });
    }
  }, [me?.agreement]);

  // показываем загрузку, если данные есть, чтобы избежать мелькание формы между окончанием загрузки и редиректом
  if (meLoading || me?.agreement) return <CircularLoading />;

  return (
    <Card sx={{ flexGrow: { xs: 1, sm: 0 }, display: 'flex', flexDirection: 'column' }}>
      <Typography variant='h28' mb={{ xs: 1.5, sm: 2 }}>
        {t('confirmUserData.greeting')}
      </Typography>
      <Typography variant='subtitle18rg' mb={4} component='p'>
        {t('confirmUserData.instructions')}
      </Typography>
      <Form form={form}>
        <Stack spacing={3} mb={3}>
          <AgreementCheckbox checkboxControlProps={{ disabled: !!me?.agreement }} />
        </Stack>
      </Form>
      <Box flex={{ xs: 1, sm: 0 }} />
      <Button
        onClick={handleSubmit(onSaveCandidateData)}
        loading={saveAgreementLoading}
        variant='contained'
        size='large'
        fullWidth>
        {t('login')}
      </Button>
    </Card>
  );
};

export default ConfirmData;
